import { render, staticRenderFns } from "./Login-1.vue?vue&type=template&id=8835c8fc&scoped=true"
import script from "./Login-1.vue?vue&type=script&lang=js"
export * from "./Login-1.vue?vue&type=script&lang=js"
import style0 from "./Login-1.vue?vue&type=style&index=0&id=8835c8fc&prod&scoped=true&lang=css"
import style1 from "./Login-1.vue?vue&type=style&index=1&id=8835c8fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8835c8fc",
  null
  
)

export default component.exports